import { render } from "./Login.vue?vue&type=template&id=2ba3a286"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ruisilva/Desktop/Projects/qmulher/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__